export default "__VITE_ASSET__617a096c__"